export const FETCH_RECIPES = 'FETCH_RECIPES';
export const FETCH_RECIPE = 'FETCH_RECIPE';
export const FETCH_SHOPLIST = 'FETCH_SHOPLIST';
export const SET_CURRENT_USER = 'SET_CURRENT_USER';